/*=========================================================================================
  File Name: moduleEcommerceActions.js
  Description: Ecommerce Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from "axios";
import auth from '@/auth/authService'


export default {
  toggleItemInWishList ({ commit }, item) {
    commit('TOGGLE_ITEM_IN_WISH_LIST', item)
  },
  toggleItemInCart ({ getters, commit, dispatch }, item) {
    getters.isInCart(item.objectID) ? commit('REMOVE_ITEM_FROM_CART', item) : dispatch('additemInCart', item)
  },
  additemInCart ({ commit }, item) {

    // Below properties should be added as per requirement from back-end
    // This is added just for demo purpose
    item['quantity'] = 1
    item['discount_in_percentage'] = Math.floor(Math.random() * 20) + 4
    item['offers_count'] = Math.floor(Math.random() * 4) + 1
    item['delivery_date'] = new Date(new Date().getTime() + (Math.random() * 10 * 24 * 60 * 60 * 1000)).toDateString().slice(0, -4)

    commit('ADD_ITEM_IN_CART', item)
  },
  updateItemQuantity ({ commit }, payload) {
    commit('UPDATE_ITEM_QUANTITY', payload)
  },
  updateViewType ({ commit }, payload) {
    commit('UPDATE_VIEW_TYPE', payload)
  },
  async getClient ({ commit }, payload) {
    try {
      commit('setClient', null)
      const {data} = await axios.post(''+auth.connectionFrontEnd()+'/webapi/clienteEC'
      ,{  codemp: payload.codemp, rucced: payload.rucced}
      , { headers: { token: payload.token } }
      )
      commit('setClient', data[0])
    } catch (e) {
      console.log(e)
    } 
  },
  async getProducts ({ commit }, payload) {
    try {
      commit('eCommerce/setProducts', [], { root: true })
      commit('eCommerce/setCantPage', 0, { root: true })
      const dataProduct = await
      axios.post(''+auth.connectionFrontEnd()+'/webapi/getArticulos'
          ,{codemp: payload.codemp, pagina: payload.pagina, codcla: payload.codcla, search: payload.search, maxpre: payload.maxpre, minpre: payload.minpre, orden: payload.orden, lispre: payload.lispre, exis: payload.exis, itemsp: payload.itemspage}
          , { headers: { token: payload.token } }
        )
      const Products = await dataProduct.data.articulos
      commit('eCommerce/setProducts', Products, { root: true })
      commit('eCommerce/setCantPage', Math.ceil((Products[0] ? Products[0].total_count : 0)/payload.itemspage), { root: true })
    } catch (e) {
      console.log(e)
    } 
  },
  async saveOrder({ commit }, payload) {
    try {
      commit('eCommerce/UPDATE_ORDERS', [], { root: true })
      const obj={ codemp: payload.emp, codven: payload.ven, pedido: payload.ped }
      const dataOrder = await
      axios.post(''+auth.connectionFrontEnd()+'/webapi/pedidosEC'
        , { codemp: payload.emp, codven: payload.ven, pedido: payload.ped }
        , { headers: { token: payload.token } }
      )
      commit('eCommerce/UPDATE_ORDERS', dataOrder, { root: true })
    } catch (e) {
      console.log(e)
    } 
  },
  recalcular({ commit }, payload){

    commit('eCommerce/UPDATE_subTotalState', 0, { root: true })
    commit('eCommerce/UPDATE_descuentoState', 0, { root: true })
    commit('eCommerce/UPDATE_totalNetoState', 0, { root: true })
    commit('eCommerce/UPDATE_grabaIvaState', 0, { root: true })
    commit('eCommerce/UPDATE_noGrabaIvaState', 0, { root: true })
    commit('eCommerce/UPDATE_ivaState', 0, { root: true })
    commit('eCommerce/UPDATE_totalState', 0, { root: true })
    commit('eCommerce/UPDATE_pedidoState', {}, { root: true })

    var pordes = payload.pordes
    var _currentEncabezadoPedido = {}
    var _params = payload.paramS;
    var lispre = payload.lispreS;
    var desart = payload.desartS; 
    var renglones = payload.rengloneS;
    var _subtotEnca = 0;
    var _totivaEnca = 0;
    var _sumdesg = 0;
    var _sumexcen = 0;
    var _descuCli = (pordes ? pordes : 0);

    for (var product in renglones){
      var renglon = renglones[product];
      renglon.ivaren = 0;
      var _subtot = parseFloat((renglon.quantity * renglon['prec0'+lispre]).toFixed(4))
      var _descren = parseFloat((_subtot * ((renglon['desc'+desart] ? renglon['desc'+desart] : 0) / 100)).toFixed(4));
      var _totren = parseFloat((_subtot - _descren).toFixed(4));
      renglon.totren = _totren;
      var _descli = parseFloat((_totren * (_descuCli / 100)).toFixed(4));

      var _totbasea = parseFloat((_totren - _descli).toFixed(4));

      if (renglon.poriva > 0) {
        if (_params.mv_eiva == "1") {
          renglon.subtot = _subtot;
          renglon.basea = _totbasea;
        } else if (_params.mv_eiva == "3") {
          var _desiva = parseFloat((100 + (renglon.poriva ? renglon.poriva : 0)) / 100);
          renglon.subtot = parseFloat((_subtot / _desiva).toFixed(4));
          renglon.basea = parseFloat((_totbasea / _desiva).toFixed(4));
        }
      } else {
        renglon.subtot = _subtot;
        renglon.excen = _totbasea;
      }

      renglon.valdes = parseFloat((renglon.subtot * ((renglon['desc'+desart] ? renglon['desc'+desart] : 0) / 100)));
      renglon.ivaren = parseFloat(
          ((renglon.subtot - renglon.valdes) * ((renglon.poriva ? renglon.poriva : 0) / 100)));

      _subtotEnca += renglon.totren;
      _sumdesg += renglon.basea ? renglon.basea : 0;
      _sumexcen += renglon.excen ? renglon.excen : 0;
      _totivaEnca += ((renglon.basea ? renglon.basea : 0) * (renglon.poriva / 100));

      }

      var _totdes = (_subtotEnca * ((pordes ? pordes : 0) / 100));
      var _totnet = (_subtotEnca - _totdes);

      _currentEncabezadoPedido.subtot =
        parseFloat((_subtotEnca ? _subtotEnca : 0).toFixed(4));
      _currentEncabezadoPedido.totdes =
      parseFloat((_totdes ? _totdes : 0).toFixed(4));
      _currentEncabezadoPedido.totnet =
        parseFloat((_totnet ? _totnet : 0).toFixed(4));
      _currentEncabezadoPedido.totiva =
      parseFloat((_totivaEnca).toFixed(4));
      _currentEncabezadoPedido.basea =
        parseFloat((_sumdesg ? _sumdesg : 0).toFixed(4));
      _currentEncabezadoPedido.excen =
        parseFloat((_sumexcen ? _sumexcen : 0).toFixed(4));
      _currentEncabezadoPedido.totfac =
        parseFloat(((_sumdesg ? _sumdesg : 0) + (_sumexcen ? _sumexcen : 0) + _totivaEnca).toFixed(4));

      commit('eCommerce/UPDATE_subTotalState', _currentEncabezadoPedido.subtot, { root: true })
      commit('eCommerce/UPDATE_descuentoState', _currentEncabezadoPedido.totdes, { root: true })
      commit('eCommerce/UPDATE_totalNetoState', _currentEncabezadoPedido.totnet, { root: true })
      commit('eCommerce/UPDATE_grabaIvaState', _currentEncabezadoPedido.basea, { root: true })
      commit('eCommerce/UPDATE_noGrabaIvaState', _currentEncabezadoPedido.excen, { root: true })
      commit('eCommerce/UPDATE_ivaState', _currentEncabezadoPedido.totiva, { root: true })
      commit('eCommerce/UPDATE_totalState', _currentEncabezadoPedido.totfac, { root: true })
      commit('eCommerce/UPDATE_pedidoState', _currentEncabezadoPedido, { root: true })
    },
  async getHistorialPedidos ({ commit }, payload) {
    try {
      commit('eCommerce/UPDATE_historialPedidos', [], { root: true })
      const dataPedidos = await
      axios.post(''+auth.connectionFrontEnd()+'/webapi/getHistorialPedidosEC'
        ,{codemp: payload.codemp, codcli: payload.codcli, fecini: payload.firstDay, fecfin: payload.lastDay }
        , { headers: { token: payload.token } }
      )
      const Pedidos = await dataPedidos.data.data
      commit('eCommerce/UPDATE_historialPedidos', Pedidos, { root: true })
    } catch (e) {
      console.log(e)
    } 
  },
  async getEmpresas ({ commit }) {
    try {
      commit('eCommerce/UPDATE_empresas', [], { root: true })
      const dataEmpresas = await
      axios.get(''+auth.connectionFrontEnd()+'/webapi/empresasEC')
      const Empresas = await dataEmpresas.data
      commit('eCommerce/UPDATE_empresas', Empresas, { root: true })
    } catch (e) {
      this.$vs.notify({
        title: 'Server Attempt',
        text: 'No se pudo conectar al servidor',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
    } 
  },
  async getParamsCompany ({ commit }, payload) {
    try {
      commit('eCommerce/UPDATE_paramsCompany', [], { root: true })
      const dataParamsC = await
      axios.post(''+auth.connectionFrontEnd()+'/webapi/paramsEC', {codemp: payload})
      const ParamsC = await dataParamsC.data[0]
      commit('eCommerce/UPDATE_paramsCompany', ParamsC, { root: true })
    } catch (e) {
      this.$vs.notify({
        title: 'Server Attempt',
        text: 'No se pudo conectar al servidor',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
    } 
  },
  async getClaseState ({ commit }, payload) {
    try {
      commit('eCommerce/UPDATE_clases', [], { root: true })
      const dataClases = await
      axios.post(''+auth.connectionFrontEnd()+'/webapi/clasesclienteEC',
      {codemp: payload}
      )
      const Clases = await dataClases.data
      commit('eCommerce/UPDATE_clases', Clases, { root: true })
    } catch (e) {
      this.$vs.notify({
        title: 'Server Attempt',
        text: 'No se pudo conectar al servidor',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
    } 
  },
  async getZonaState ({ commit }, payload) {
    try {
      commit('eCommerce/UPDATE_zonas', [], { root: true })
      const dataZonas = await
      axios.post(''+auth.connectionFrontEnd()+'/webapi/zonasEC',
      {codemp: payload}
      )
      const Zonas = await dataZonas.data
      for(var z in Zonas){
        Zonas[z].fullzona = Zonas[z].nomzona + ' '+Zonas[z].dirzona;
      }
      commit('eCommerce/UPDATE_zonas', Zonas, { root: true })
    } catch (e) {
      this.$vs.notify({
        title: 'Server Attempt',
        text: 'No se pudo conectar al servidor',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
    } 
  },
  async getCuentasCobrarEC ({ commit }, payload) {
    try {
      commit('eCommerce/UPDATE_cuentasCobrarState', [], { root: true })
      const dataCuentasC = await
      axios.post(''+auth.connectionFrontEnd()+'/webapi/getCuentasCobrarEC'
        ,{codcli: payload.codcli }
        , { headers: { token: payload.token } }
      )
      const CuentasC = await dataCuentasC.data
      commit('eCommerce/UPDATE_cuentasCobrarState', CuentasC, { root: true })
    } catch (e) {
      console.log(e)
    } 
  },
}
